import { FC } from 'react';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import styles from '@/common/components/business/ExpandStore/TaskDeatil/components/BasicInfo.tsx/index.module.less';

/** 拓店任务：加盟（三津汤包）-详情-顶部信息 */
const TaskOverview: FC<{
  detail: any;
}> = ({ detail }) => {
  const infos: any[] = [
    { label: '选址类型', value: detail?.taskTypeName, maxWidth: '106px' },
    { label: '加盟商姓名', value: detail?.standardFranchiseeName || detail?.franchiseeDetail?.name, maxWidth: '96px' },
    { label: '招商人员', value: detail?.investmentManagerName, maxWidth: '106px' },
    { label: '拓展人员', value: detail?.expansionManagerName || detail?.manager || detail?.developManager, maxWidth: '106px' },
  ];

  return <div className='pb-4'>
    <V2DetailGroup moduleType='easy' className={styles.basicInfo}>
      {
        infos.map((item, index) => <div
          style={{
            maxWidth: item?.maxWidth,
            width: item?.maxWidth,
          }}
          className={styles.card}
          key={index}>
          <V2DetailItem label={item?.label} value={item?.value} />
        </div>)
      }
    </V2DetailGroup>
  </div>;
};

export default TaskOverview;
